module.exports = __webpack_public_path__ + "img/title-l.cdf1924e.svg";